// Jquery declaration
import $ from 'jquery';
global.$ = global.jQuery = $;

// Import packages
import 'bootstrap';
import 'blueimp-file-upload';
import 'jqueryAjaxcom/ajaxcom';
import browserUpdate from 'browser-update';
import flatpickr from 'flatpickr';

// Import local modules
import './modules/address-lookup.js';
import './modules/postcode-lookup.js';
import ErrorTracker from './modules/error-tracker';

$(function(){
    new ErrorTracker();

    const updateContainer = document.getElementById('browserupdate-container');

    if (updateContainer) {
        browserUpdate({
            required:{e:-4,f:-4,o:-4,s:-4,c:-4},
            api:2020.11,
            no_permanent_hide: true,
            noclose: true,
            container: updateContainer,
            text: "Your browser ({brow_name}) is too old, which may cause unexpected problems with this site. <a{up_but}>Update your browser</a>"
        });
    }
});

$.fn.bindDatePicker = function (opts) {
    const callback = (opts && typeof opts.callback === 'function') ? opts.callback : $.noop;

    const defaultOpts = {
        altFormat: 'F j, Y',
        dateFormat: 'd/m/Y',
        allowInput: true,
        time_24hr: true
    };

    function addDatepicker() {
        // IE11 doesn't support '.closest' - remove jQuery reference once IE11 dies
        const modal = $(this).closest('.modal')[0];
        const t = this;

        let options = {
            ...defaultOpts,
            minDate: this.dataset.min,
            maxDate: this.dataset.max,
            enableTime: this.dataset.time,
            onOpen: function(){
                if (modal) modal.removeAttribute('tabindex'); // Fix for flatpickr in bootstrap modal
            },
            onClose: function(){
                if (modal) modal.setAttribute('tabindex', -1); // Fix for flatpickr in bootstrap modal

                // Send this element back with callback to save part of form
                callback(t);
           }
        };

        if (this.dataset.format) {
            options.dateFormat = this.dataset.format;

            // Time format only - disable calendar
            if (this.dataset.format.length < 5) {
                options.noCalendar = true;
            }
        }

        if (!this._flatpickr) flatpickr(this, options);
    }

    const $target = this.hasClass('flatpickr') ? this : this.find('.flatpickr');
    $target.each(addDatepicker);
};
